import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import {
  COLOR_BLACK_HAZE,
  COLOR_DENIM,
  COLOR_DISABLED_BG,
  COLOR_REGENT_ST_BLUE,
  FONT_SIZE_16_PX,
} from 'popTheme';
import * as style from './QuestionPanel.style';

export const Questions = ({
  isQuestion,
  question,
  subQuestion,
  isPreviousDisabled,
  isNextDisabled,
  onPrevious,
  onNext,
  children,
}) => {
  const getButtonStyle = (isDisabled) => ({
    width: { xs: FONT_SIZE_16_PX, md: '1.5rem' },
    height: { xs: FONT_SIZE_16_PX, md: '1.5rem' },
    border: `0.09375rem solid ${isDisabled ? COLOR_REGENT_ST_BLUE : COLOR_DENIM}`,
    borderRadius: '0.75rem',
    color: isDisabled ? COLOR_REGENT_ST_BLUE : COLOR_DISABLED_BG,
    bgcolor: isDisabled ? COLOR_BLACK_HAZE : COLOR_DENIM,
  });

  return <Paper data-testid="questions-component"
                variant="elevation"
                elevation={1}
                sx={[style.card, isQuestion ? style.questionCard : style.descriptiveCard]}>
    <Box>{question}</Box>
    <Box sx={style.subQuestion}>{subQuestion}</Box>
    {children}
    <Box sx={style.navigation}>
      <IconButton disableRipple disabled={isPreviousDisabled()} onClick={onPrevious}>
        <ChevronLeft sx={{ ...getButtonStyle(isPreviousDisabled()) }}/>
      </IconButton>
      <IconButton disableRipple disabled={isNextDisabled()} onClick={onNext}>
        <ChevronRight sx={{ ...getButtonStyle(isNextDisabled()) }}/>
      </IconButton>
    </Box>
  </Paper>
};

Questions.propTypes = {
  isQuestion: PropTypes.bool,
  children: PropTypes.node,
  isPreviousDisabled: PropTypes.func.isRequired,
  isNextDisabled: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};
